import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./navbar.css";
import Google from "components/auth/google";
import Admin_btn from "components/General/admin-btn/admin-btn";

const Navbar = () => {
  const [opened, setOpened] = useState(false);
  const [solid, setSolid] = useState(true);
  const location = useLocation();
  let openMenu = (e) => {
    if (opened) {
      setOpened(false);
    } else {
      setOpened(true);
    }
  };

  // document.addEventListener('scroll', () => {
  //   if(window.scrollY > 60){
  //     setSolid(true)
  //   }else{
  //     setSolid(false)
  //   }
  // });

  return (
    <>
      <nav id="navbar" className={solid ? "navbar solid" : "navbar"}>
        <div className="nav-wrapper">
          <div className="logoNavbar">
            <a href="#home">
              <i className="fas fa-fighter-jet"></i> AIRCHEATS
            </a>
          </div>

          <ul id="menu">
            <li>
              <a
                href="#home"
                className={location.pathname.includes("home") ? "active" : null}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#cheats/all"
                className={
                  location.pathname.includes("cheats") ||
                  location.pathname.includes("cheat")
                    ? "active"
                    : null
                }
              >
                Cheats
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className={
                  location.pathname.includes("contact") ? "active" : null
                }
              >
                Contact
              </a>
            </li>
            <li className="google_navbar_button">
              <Google />
            </li>
          </ul>
        </div>
      </nav>

      <div
        className={opened ? "menuIcon toggle" : "menuIcon"}
        onClick={openMenu}
      >
        <span className="icon icon-bars"></span>
        <span className="icon icon-bars overlay"></span>
      </div>

      <div className={opened ? "overlay-menu openMenu" : "overlay-menu"}>
        <ul id="menu" className="menu">
          <li>
            <a href="#home" onClick={() => setOpened(false)}>
              Home
            </a>
          </li>
          <li>
            <a href="#cheats/all" onClick={() => setOpened(false)}>
              Cheats
            </a>
          </li>
          <li>
            <a href="#contact" onClick={() => setOpened(false)}>
              Contact
            </a>
          </li>
          <li className="google_navbar_button" onClick={() => setOpened(false)}>
            <Google />
          </li>
        </ul>
      </div>
      <Admin_btn />
    </>
  );
};

export default Navbar;
